import {Box, Paper, Typography} from "@mui/material";

export default function MacroRegionSettingsPage(){
    return(
        <Paper elevation={3}>
            <Box p={2} style={{height: 600}}>
                <Typography variant="h5" component="h1">Macro Region Page</Typography>
            </Box>
        </Paper>
    );
}
